<template>
  <div>
    <div class="d-flex align-items-center justify-content-between">
      <h4 class="">
        <feather-icon class="align-middle" size="20" icon="TruckIcon" />
        الآليات
      </h4>
      <b-button
        variant="success"
        @click="onAddClicked"
        v-can="{ slug: $route.meta.slug, action: 'C' }"
      >
        <feather-icon icon="PlusIcon" class="mr-50" />
        إضافة آلية
      </b-button>
    </div>
    <hr />
    <data-table
      ref="vehiclesTable"
      ep="v2/machines"
      :fields="fields"
      v-can="{ slug: $route.meta.slug, action: 'S' }"
    >
      <template #cell(fuel_type)="{ item }">
        {{ item.fuelType ? item.fuelType.name_ar : ''}}
      </template>
      <template #cell(tax)="{ item }">
        {{ item.tax === false ? "غير معفاة" : "معفاة" }}
      </template>
      <template #cell(possession_document)="{ item }">
        <b-button
          target="_blank"
          rel="noopener noreferrer"
          :to="{ name: 'file-view', query: { ep: item.ownership_doc } }"
          variant="flat-info"
          size="sm"
        >
          <div class="d-flex">
            <feather-icon class="mr-50" icon="EyeIcon" size="16" />
            عرض
          </div>
        </b-button>
      </template>
      <template #cell(actions)="row">
        <div class="d-flex justify-content-center align-items-center">
          <b-badge
            v-if='row.item.old_ngo_id'
            pill
            variant="light-primary"
          >
            منقول من المنظمة المندمجة
          </b-badge>
          <b-badge
            v-if='row.item.international_donation_id'
            pill
            variant="light-secondary"
          >
              تبرع خارجي
          </b-badge>
          <b-badge
            v-if='row.item.national_donation_id'
            pill
            variant="light-success"
          >
              تبرع داخلي
          </b-badge>
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
  
            <b-dropdown-item
              @click="onUpdateClicked(row.item)"
              v-can="{ slug: $route.meta.slug, action: 'U' }"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">تعديل</span>
            </b-dropdown-item>
  
            <b-dropdown-item
              @click="onDelete(row.item.id)"
              v-can="{ slug: $route.meta.slug, action: 'D' }"
            >
              <feather-icon icon="Trash2Icon" />
              <span class="align-middle ml-50">حذف</span>
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </template>
    </data-table>
    <form-modal
      ref="vehicleModal"
      :formSchema="vehicleFormSchema"
      title="إضافة آلية"
      v-model="formModal"
      @confirm="onModalConfirmed"
      :loading="loading"
    >
      <template #tax="{ form }">
        <b-form-checkbox class="my-1 mx-50" v-model="form.tax">
          معفاة من الضرائب
        </b-form-checkbox>
      </template>
      <template #ownership_doc="{ form }">
        <form-file-input
          placeholder="اختر ملفاً"
          id="document"
          label="وثيقة الملكية"
          accept=".doc,.pdf,.docx"
          v-model="form.ownership_doc"
          rules="required"
          :key="formModal"
        />
      </template>
    </form-modal>
  </div>
</template>

<script>
import dataTable from "@/components/data-table";
import {
  BButton,
  BFormFile,
  BFormCheckbox,
  BFormGroup,
  BDropdown,
  BDropdownItem,
  BBadge
} from "bootstrap-vue";
import * as ep from "../../endpoints";
import FormModal from "@/components/FormModal.vue";
import { mapActions, mapGetters } from "vuex";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import FormFileInput from "@/components/FormFileInput.vue";
export default {
  components: {
    dataTable,
    BButton,
    BFormFile,
    BFormCheckbox,
    BFormGroup,
    FormModal,
    BDropdown,
    BDropdownItem,
    FormFileInput,
    BBadge
  },
  methods: {
    ...mapActions("Properties", [
      "addProperty",
      "updateProperty",
      "deleteProperty",
    ]),
    getYears() {
      var x = [];
      for (let index = 1900; index < this.$moment().year(); index++) {
        x.push(`${index}`);
      }
      return x.reverse();
    },
    onUpdateClicked(form) {
      var toUpdate = {
        id: form.id,
        model: form.model,
        plate_number: form.plate_number,
        serial_number: form.serial_number,
        structure_no: form.structure_no,
        fuel_type_id: form.fuelType,
        passengers_number: form.passengers_number,
        year: form.year,
        tax: form.tax,
        machine_type_id: form.machine_type_id,
        governorate_id: form.governorate_id,
        possessive_form_id: form.possessive_form_id,
        ownership_doc: form.ownership_doc,
      };
      this.$refs.vehicleModal.init(toUpdate);
      this.formModal = true;
    },
    onAddClicked() {
      this.$refs.vehicleModal.init({ tax: false });
      this.formModal = true;
    },
    onDelete(id) {
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من حذف الآلية؟", {
          title: "تأكيد حذف الآلية",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value)
            this.deleteProperty({ ep: ep.VEHICLE_BY_ID(id) }).then(() => {
              this.$refs.vehiclesTable.refreshTable();
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "تم الحذف بنجاح",
                  icon: "CheckSquareIcon",
                  variant: "success",
                },
              });
            });
        });
    },
    onModalConfirmed(form) {
      if (form.id) {
        const toUpdate = { ...form };
        if (typeof toUpdate.ownership_doc === "string")
          delete toUpdate.ownership_doc;
        this.updateProperty({
          ep: ep.VEHICLE_BY_ID(toUpdate.id),
          form: { ...toUpdate, tax: toUpdate.tax === false ? 0 : 1 },
        }).then(() => {
          this.$refs.vehiclesTable.refreshTable();
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "تم التعديل بنجاح",
              icon: "CheckSquareIcon",
              variant: "success",
            },
          });
          this.formModal = false;
        });
      } else
        this.addProperty({
          ep: ep.VEHICLE,
          form: { ...form, tax: form.tax === false ? 0 : 1 },
        }).then(() => {
          this.$refs.vehiclesTable.refreshTable();
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "تمت الإضافة بنجاح",
              icon: "CheckSquareIcon",
              variant: "success",
            },
          });
          this.formModal = false;
        });
    },
  },
  data() {
    return {
      formModal: false,
      initForm: {},
      vehicleFormSchema: {
        machine_type_id: {
          component: "FormSelect",
          key: "machine_type_id",
          attrs: {
            id: "vehicle-type",
            label: "نوع المركبة*",
            rules: "required",
            ep: "v2/selects/machine-types",
            reduce: (x) => x.id,
            getOptionLabel: (x) => x.name_ar,
          },
        },
        model: {
          component: "FormInput",
          key: "model",
          attrs: {
            label: "الطراز*",
            rules: "required",
          },
        },
        plate_number: {
          component: "FormInput",
          key: "plate_number",
          attrs: {
            label: "رقم اللوحة*",
            rules: "required",
          },
        },
        governorate_id: {
          component: "FormSelect",
          key: "governorate_id",
          attrs: {
            id: "vehicles-gov",
            label: "المحافظة*",
            ep: "v2/selects/governorates",
            reduce: (x) => x.id,
            getOptionLabel: (x) => x.name_ar,
            rules: "required",
          },
        },
        serial_number: {
          component: "FormInput",
          key: "serial_number",
          attrs: {
            label: "الرقم التسلسلي*",
            rules: "required",
          },
        },
        structure_no: {
          component: "FormInput",
          key: "structure_no",
          attrs: {
            label: "رقم الهيكل*",
            rules: "required",
          },
        },
        engine_number: {
          component: "FormInput",
          key: "engine_number",
          attrs: {
            label: "رقم المحرك*",
            rules: "required",
          },
        },
        color: {
          component: "FormInput",
          key: "color",
          attrs: {
            label: "اللون*",
            rules: "required",
          },
        },
        year: {
          component: "FormSelect",
          key: "year",
          attrs: {
            id: "year",
            label: "سنة الصنع*",
            rules: "required",
            options: this.getYears(),
          },
        },
        fuel_type_id: {
          component: "FormSelect",
          key: "fuel_type_id",
          attrs: {
            id: "fuel_type_id",
            label: "نوع الوقود*",
            rules: "required",
            reduce: (x) => x.id,
            getOptionLabel: (x) => x.name_ar,
            ep:"v2/selects/fuel-types"
          },
        },
        passengers_number: {
          component: "FormInput",
          key: "passengers_number",
          attrs: {
            label: "عدد الركاب*",
            rules: "required|integer|min:1|max:2",
          },
        },
        possessive_form_id: {
          component: "FormSelect",
          key: "possessive_form_id",
          attrs: {
            id: "possiveForm",
            label: "صيغة التملك*",
            rules: "required",
            ep: "v2/selects/possessive-forms",
            reduce: (x) => x.id,
            getOptionLabel: (x) => x.name_ar,
          },
        },

        ownership_doc: {
          key: "ownership_doc",
        },
        tax: {
          key: "structure_no",
        },
      },
      fields: [
        {
          key: "id",
          label: "المعرف",
        },
        { key: "model", label: "الطراز", sortable: true },
        { key: "plate_number", label: "رقم اللوحة", sortable: true },
        {
          key: "serial_number",
          label: "الرقم التسلسلي",
          sortable: true,
        },
        {
          key: "structure_no",
          label: "رقم الهيكل",
        },
        {
          key: "engine_number",
          label: "رقم المحرك",
        },
        {
          key: "color",
          label: "اللون",
        },
        {
          key: "fuel_type",
          label: "نوع الوقود",
        },
        {
          key: "passengers_number",
          label: "عدد الركاب",
        },
        {
          key: "year",
          label: "سنة الصنع",
        },
        {
          key: "tax",
          label: " حالة الضرائب",
        },
        {
          key: "possession_document",
          label: " وثيقة الملكية",
        },
        { key: "actions", label: "الأوامر" },
      ],
    };
  },
  computed: {
    ...mapGetters("Properties", ["loading"]),
  },
};
</script>
